var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgYoutube = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.582 2.19395C19.352 1.3334 18.6744 0.655781 17.8139 0.42582C16.254 0.00781235 9.99992 0.0078125 9.99992 0.0078125C9.99992 0.0078125 3.74582 0.00781235 2.18594 0.42582C1.32559 0.655781 0.647812 1.3334 0.417812 2.19395C0 3.75363 0 7.00785 0 7.00785C0 7.00785 0 10.2621 0.417812 11.8216C0.647812 12.6821 1.32559 13.3599 2.18594 13.5899C3.74582 14.0077 9.99992 14.0077 9.99992 14.0077C9.99992 14.0077 16.254 14.0077 17.8139 13.5899C18.6744 13.3599 19.352 12.6821 19.582 11.8216C20 10.2621 20 7.00785 20 7.00785C20 7.00785 20 3.75363 19.582 2.19395Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00049 10.0118L13.1965 7.01176L8.00049 4.01172V10.0118Z",
    fill: "#0E1F3C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgYoutube);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/youtube.b04947ac31def67e2663467ec0799e20.svg";